// eslint-disable-next-line no-restricted-exports
import Triggers from './Triggers';

export default Triggers;
